import { render, staticRenderFns } from "./HomeLoansProvider.vue?vue&type=template&id=940d4b68&"
import script from "./HomeLoansProvider.vue?vue&type=script&lang=js&"
export * from "./HomeLoansProvider.vue?vue&type=script&lang=js&"
import style0 from "../../assets/style/base.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports